document.addEventListener('DOMContentLoaded', function () {
  let currentUrl = window.location.href; // Get the current URL
  let customNavButtons = document.querySelectorAll('.custom_nav_button'); // Get all buttons
  let baseBlogUrl = '{{ blog.url }}'; // Store the base blog URL

  customNavButtons.forEach(function (button) {
    // Check if the current URL matches the button's href exactly
    if (currentUrl === button.href) {
      button.classList.add('active'); // Add 'active' class if it matches the URL
    } else {
      button.classList.remove('active'); // Remove 'active' class if it doesn't match
    }
  });

  // Ensure "All" is active only if the URL matches the base blog URL without filters
  if (currentUrl === baseBlogUrl) {
    document.querySelector('.custom_nav_button[href="{{ blog.url }}"]').classList.add('active');
  }
});
